import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import PaginatedListState from 'flarum/common/states/PaginatedListState';
import EventEmitter from 'flarum/common/utils/EventEmitter';
const globalEventEmitter = new EventEmitter();
export default class PollListState extends PaginatedListState {
  constructor(params, page) {
    if (page === void 0) {
      page = 1;
    }
    super(params, page, 20);
    _defineProperty(this, "extraPolls", []);
    _defineProperty(this, "eventEmitter", void 0);
    this.eventEmitter = globalEventEmitter.on('poll.deleted', this.deletePoll.bind(this));
  }
  get type() {
    return 'polls';
  }
  getSort() {
    return this.params.sort || '-createdAt';
  }
  setSort(sort) {
    this.params.sort = sort;
    this.refresh();
  }
  requestParams() {
    const params = {
      include: this.requestIncludes(),
      filter: this.params.filter || {},
      sort: this.getSort()
    };
    if (this.params.q) {
      params.filter.q = this.params.q;
    }
    return params;
  }
  includes() {
    return ['options', 'votes'];
  }
  requestIncludes() {
    const standard = this.includes();

    // merge the standard includes with the custom includes
    const merged = [...standard, ...(this.params.include || [])];

    // return as a comma separated string
    return merged.join(',');
  }
  loadPage(page) {
    if (page === void 0) {
      page = 1;
    }
    const preloadedPolls = app.preloadedApiDocument();
    if (preloadedPolls) {
      this.initialLoading = false;
      return Promise.resolve(preloadedPolls);
    }
    return super.loadPage(page);
  }
  clear() {
    super.clear();
    this.extraPolls = [];
  }

  /**
   * Get a map of sort keys (which appear in the URL, and are used for
   * translation) to the API sort value that they represent.
   */
  sortMap() {
    const map = {};
    if (this.params.q) {
      map.relevance = '';
    }
    map.newest = '-createdAt';
    map.oldest = 'createdAt';
    map.most_voted = '-voteCount';
    map.least_voted = 'voteCount';
    return map;
  }

  /**
   * In the last request, has the user searched for a poll?
   */
  isSearchResults() {
    return !!this.params.q;
  }
  removePoll(poll) {
    PollListState.notifyDeleted(poll);
  }

  /**
   * Notify all live PollListState instances that a poll was deleted (or moved
   * out of the active view, e.g. published-only ↔ drafts) so they splice it
   * out of their pages without a full reload.
   */
  static notifyDeleted(poll) {
    globalEventEmitter.emit('poll.deleted', poll);
  }
  deletePoll(poll) {
    for (const page of this.pages) {
      const index = page.items.indexOf(poll);
      if (index !== -1) {
        page.items.splice(index, 1);
        break;
      }
    }
    const index = this.extraPolls.indexOf(poll);
    if (index !== -1) {
      this.extraPolls.splice(index, 1);
    }
    m.redraw();
  }

  /**
   * Add a poll to the top of the list.
   */
  addPoll(poll) {
    this.removePoll(poll);
    this.extraPolls.unshift(poll);
    m.redraw();
  }
  getAllItems() {
    return this.extraPolls.concat(super.getAllItems());
  }
  getPages() {
    const pages = super.getPages();
    if (this.extraPolls.length) {
      return [{
        number: -1,
        items: this.extraPolls
      }, ...pages];
    }
    return pages;
  }
}
flarum.reg.add('fof-polls', 'forum/states/PollListState', PollListState);